import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import {
    mdiArrowCollapse,
    mdiArrowExpand,
    mdiChevronDown,
    mdiChevronUp,
    mdiFilterOutline,
    mdiLaunch,
    mdiLockOutline,
    mdiRefresh,
} from '@mdi/js';

import { ClickOutsideDirective } from './card-component-click-outside.directive';
import { CmpsCardComponent } from './card-component.component';

@NgModule({
    declarations: [CmpsCardComponent, ClickOutsideDirective],
    imports: [
        CommonModule,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsTooltipModule,
    ],
    exports: [CmpsCardComponent],
})
export class CmpsCardComponentModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['refresh', mdiRefresh],
            ['filter', mdiFilterOutline],
            ['expand', mdiArrowExpand],
            ['chevron-up', mdiChevronUp],
            ['chevron-down', mdiChevronDown],
            ['lock', mdiLockOutline],
            ['collapse', mdiArrowCollapse],
            ['launch', mdiLaunch],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
